import { Component, EventEmitter, h, Prop, Event } from '@stencil/core';

@Component({
  tag: 'pnk-input',
  styleUrl: 'pnk-input.css',
})
export class PnkInput {
  @Prop() label: string = '';

  @Prop() type: string = 'text';

  @Prop() placeholder: string = '';

  @Prop({ mutable: true }) value: string | number | undefined;

  @Prop({ mutable: true }) errorLabel: string = '';

  @Prop({ mutable: true }) error: boolean = false;

  @Prop({ mutable: true }) disabled: boolean = false;

  @Prop() flat: boolean = false;

  @Event()
  changed!: EventEmitter<string | number | null>;

  inputElement!: HTMLInputElement;

  handleChange() {
    if (this.value === typeof Number) {
      this.value = Number(this.inputElement.value);
    } else {
      this.value = this.inputElement.value;
    }
    this.changed.emit(this.value);
  }

  getStyle() {
    const style = ['pnk-p-2.5 pnk-rounded-def pnk-border pnk-w-inherit pnk-h-10 '];
    if (this.error) {
      style.push('pnk-bg-error pnk-text-white');
    } else if (this.disabled) {
      style.push('pnk-bg-disabled-text pnk-text-white');
    } else {
      style.push('pnk-text-black pnk-bg-disabled-base');
    }
    return style.join('');
  }

  render() {
    return (
      <div class="input-container pnk-flex pnk-flex-col">
        {!this.flat ? <label class="pnk-text-small pnk-ml-2 pnk-mb-[2px] pnk-font-bold pnk-font-base pnk-text-disabled-text">{this.label}</label> : null}
        <input
          type={this.type}
          class={this.getStyle()}
          placeholder={this.placeholder ?? (this.flat ? this.label : '')}
          value={this.value}
          onChange={() => this.handleChange()}
          disabled={this.disabled}
          ref={el => (el ? (this.inputElement = el) : null)}
        />
        {this.error ? <span class="pnk-text-error pnk-text-xs pnk-ml-2 pnk-mt-1">{this.errorLabel}</span> : null}
      </div>
    );
  }
}
